__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "corrections";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "15.2.10", () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(58987))))));
			register("@angular/common", "15.2.10", () => (__webpack_require__.e(129).then(() => (() => (__webpack_require__(94666))))));
			register("@angular/core", "15.2.10", () => (__webpack_require__.e(560).then(() => (() => (__webpack_require__(22560))))));
			register("@angular/material/legacy-dialog", "15.2.9", () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(58446))))));
			register("@angular/router", "15.2.10", () => (__webpack_require__.e(547).then(() => (() => (__webpack_require__(53547))))));
			register("@xpo-ltl/config-manager", "15.1.3", () => (__webpack_require__.e(162).then(() => (() => (__webpack_require__(69162))))));
			register("@xpo-ltl/sdk-documentmanagement", "6.1.11", () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(70526))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};